export default {
    type: 'set',
    format: {
        searchOnly: true
    },
    default: {
        logic: 'match',
        tolerance: 2,
        operand: '>=',
        value: []
    },
    setting: {
        logic: ['match', 'oneof', 'someof', 'allof']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Publishers',
        category: 'Game',
        description: 'Company or brand that published the game.',
        summarise: {
            prefix: 'Game publisher'
        },
        unit: 'publisher'
    },
    rules: {
        linked: [],
        legacy: ['publishers']
    }
}